<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <el-divider style="font-size: 16px;">
            <div style="font-size: 20px;font-weight: bold;">{{make_form_title}}</div>
          </el-divider>
        </div>
        <div style="padding: 10px;">

          <el-form ref="editForm" :model="editForm" :rules="form_rules" size="mini">
            <div style="margin-left: 5px;">
              <div style="font-size: 16px;font-weight: bold;display: flex;align-items: center;color:red;">1.表格名称(必填)
              </div>
              <el-form-item :required="true">
                <el-input v-model="editForm.form_name" style="width: 50%;font-size: 16px;margin-top: 10px;"
                  placeholder="这里填写表格名称"></el-input>
              </el-form-item>
              <!--              <div style="font-size: 16px;font-weight: bold;"><span style="color: red;">*</span><span
                  style="color: red;">第2步:</span>选择填写张数</div>
              <el-form-item :required="true" style="margin-top: 10px;">
                <el-radio-group v-model="editForm.input_pages" size="medium">
                  <el-radio border label="1">每人只限填写一张</el-radio>
                  <el-radio border label="9999">不受填写张数限制,每人可填写多张</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <div style="font-size: 16px;">2.领表须知(选填)</div>
              <el-form-item>
                <el-input type="textarea" :rows="2" style="width: 50%;font-size: 16px;margin-top: 10px;"
                  v-model="editForm.recieve_notice" placeholder="填表说明会在填表人填表时显示">
                </el-input>
              </el-form-item>

              <div style="font-size: 16px;">3.填表须知(选填)</div>
              <el-form-item>
                <el-input type="textarea" :rows="2" style="width: 50%;font-size: 16px;margin-top: 10px;"
                  v-model="editForm.form_comment" placeholder="填表说明会在填表人填表时显示">
                </el-input>
              </el-form-item>
            </div>
            <div style="font-size: 16px;font-weight: bold;"><span style="color: red;">4.添加表格的数据列(必填)</span></div>
            <div style="margin: 15px;">
              <div style="display: flex;justify-content: flex-start;">
                <!-- <div>增加表格数据列</div> -->
                <el-button type="primary" @click="showAddColumnDialog()"> +添加数据列</el-button>
              </div>
              <el-table ref="column_form" :data="columnData" stripe style="width: 100%">

                <el-table-column label="序号" width="50">
                  <template slot-scope="scop">
                    {{scop.$index+1}}
                  </template>
                </el-table-column>

                <el-table-column prop="column_name" label="数据列名" width="300">
                </el-table-column>
                <el-table-column prop="column_type" label="数据格式" width="150" align="center">
                </el-table-column>
                <el-table-column prop="column_optional" label="是否必填" width="150">
                  <template slot-scope="scope">
                    <div style="" v-if="scope.row.column_optional == '1'">可填可不填</div>
                    <div style="color: red;" v-else>必须填写</div>
                  </template>
                </el-table-column>
                <el-table-column prop="column_comment" label="填写说明">
                </el-table-column>

                <el-table-column prop="column_options" width="200" label="选项(单选或多选类型才有)">
                  <template slot-scope="scope">
                    <div v-if="scope.row.column_type=='单选' || scope.row.column_type=='多选'">
                      {{scope.row.column_options}}
                    </div>

                  </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="moveUp(scope.$index)">上移</el-button>
                    <el-button type="text" size="small" @click="moveDown(scope.$index)">下移</el-button>
                    <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
                    <el-button @click="editClick(scope.$index)" type="text" size="small">修改</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="display: flex;justify-content: flex-end;margin: 20px;">共{{columnData.length}}行</div>
            </div>

            <el-form-item size="large" style="display: flex;justify-content: center;">
              <el-button type="primary" @click="saveForm()">保 存 表 格</el-button>
              <el-button @click="back">返 回 列 表</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <!--表格名称-->
    <el-dialog width="40%" :close-on-click-modal="false" :title="field_action_title"
      :visible.sync="addColumnDialogVisible">
      <el-form ref="columnForm" label-width="80px" size="mini">
        <div style="">
          <el-form-item label="数据列名" :required="true">
            <el-input v-model="column_name" placeholder="这里填写数据列名称,如:姓名,电话等"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex;align-items:center;vertical-align: middle;">
          <el-form-item label="数据格式" :required="true" style="">
            <el-select v-model="column_type" placeholder="请选择" @change="selectColumnType"
              :popper-append-to-body="false">
              <el-option v-for="item in columnTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span v-if="column_type=='单选' || column_type=='多选'"
              style="font-weight: bold;text-decoration: underline;margin-left: 10px;"
              @click="editSelectItems">修改选项</span>
          </el-form-item>

        </div>


        <div style="">
          <el-form-item label="是否必填" :required="true">
            <el-radio-group v-model="column_optional" size="medium">
              <el-radio border label="0">必须填写</el-radio>
              <el-radio border label="1">可填可不填</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="填写说明">
            <el-input type="textarea" :rows="2" v-model="column_comment" placeholder="填写说明"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addColumnDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="saveColumn()">确 定</el-button>
      </div>

    </el-dialog>

    <!--粘贴输入-->
    <el-dialog width="40%" :close-on-click-modal="false" title="添加选项" :visible.sync="addOptionsDialogVisible">
      <el-form ref="columnForm" label-width="80px" size="mini">
        <div>
          <el-form-item label="选项">
            <el-input type="textarea" :rows="5" v-model="option_list_str" placeholder="输入备选项,一行一个"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelOptionsToColumn">取 消</el-button>
        <el-button type="primary" @click="addOptionsToColumn">保 存</el-button>
      </div>

    </el-dialog>


    <!--粘贴输入-->
   <el-dialog width="40%" :close-on-click-modal="false" title="保存成功" :visible.sync="saveFormSuccessDialogVisible">
      <el-form ref="columnForm" label-width="80px" size="mini">
        <div>
          表格结构保存成功！如果不需要再修改了，点“返回列表”即可。
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFormSuccessDialogVisible=false">知道了</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.form_id = this.$route.params.form_id


      // console.log('**********',this.form_id)


      this.action = this.$route.params.action

      if (this.action == 'EDIT') {
        this.make_form_title = '修改表格'
        this.loadFormStructure()
      } else {
        this.make_form_title = '新建表格'
      }
    },
    data() {
      return {
        make_form_title: '',

        form_id: '',
        action: '',
        form: '',
        form_fields: [],


        username: '',
        editForm: {
          id: '',
          form_name: '',
          form_comment: '',
          input_pages: 0,
          recieve_notice: ''
        },
        form_rules: {
          form_name: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }]
        },

        columnData: [],
        addColumnDialogVisible: false,

        column_name: '',
        column_type: '',
        column_comment: '',
        column_options: [],
        column_optional: '',
        column_field_sample: '',

        columnTypes: [{
            label: '任意内容(无固定格式)',
            value: '文本'
          }, {
            label: '数字(只能填数字)',
            value: '数字'
          }, {
            label: '身份证号(只能填写身份证号)',
            value: '身份证号'
          }, {
            label: '手机号(只能填写手机号)',
            value: '手机号'
          },
          // {
          //   label: '地址(省市县乡五级详细格式)',
          //   value: '地址'
          // },
          {
            label: '年月(格式:年-月)',
            value: '年月'
          },
          {
            label: '日期(格式:年-月-日)',
            value: '日期'
          },
          {
            label: '日期及时间(格式:年-月-日 时:分)',
            value: '日期时间'
          }, {
            label: '日期范围(格式:年-月-日 至 年-月-日)',
            value: '日期范围'
          },
          {
            label: '自动时间(无需填写,系统自动填写填表时间)',
            value: '自动时间'
          },
          {
            label: '单选(多个选项中选一个)',
            value: '单选'
          },
          {
            label: '多选(多个选项中可选多个)',
            value: '多选'
          },
          {
            label: '图片(上传一张图片)',
            value: '图片'
          },
          {
            label: '视频(上传一个视频)',
            value: '视频'
          }, {
            label: '文件(上传一个doc、xls、pdf等文件)',
            value: '文件'
          },
          // {
          //   label: '位置(自动上报填表人位置)',
          //   value: '定位'
          // },
          // {
          //   label: '地图选址(从地图上选准确位置)',
          //   value: '选址'
          // },
          {
            label: '条形码(竖线的条形码)',
            value: '条形码'
          },
          {
            label: '二维码(方形的二维码)',
            value: '二维码'
          },
          {
            label: 'Email邮箱(只能填写邮箱)',
            value: 'Email邮箱'
          },
          {
            label: '车牌号(固定格式的)',
            value: '车牌号'
          },
          {
            label: '签名(手写签名)',
            value: '签名'
          }
          // ,
          // {
          //   label: '微信手机号(自动录入和微信绑定的手机号)',
          //   value: '微信手机号'
          // }
        ],

        addOptionsDialogVisible: false,
        option_list_str: '',

        field_operation_type: '',
        edit_field_index: -1,
        field_action_title: '',

        saveFormSuccessDialogVisible: false
      }
    },
    methods: {
      back() {
        this.$router.go(-1)
      },

      showAddColumnDialog() {
        this.column_name = ''
        this.column_type = ''
        this.column_comment = ''
        this.column_options = []
        this.column_optional = ''
        this.column_field_sample = ''

        this.field_operation_type = 'ADD'
        this.field_action_title = '添加列'

        this.addColumnDialogVisible = true
      },
      saveColumn() {
        if (this.column_name === '') {
          this.$message.error('请输入列名!')
          return
        }

        if (this.field_operation_type == 'ADD') {
          if (this.isExistColumn(this.column_name)) {
            this.$message.error('"' + this.column_name + '"列已存在,请更换列名称!')
            return
          }

        }

        if (this.column_type === '') {
          this.$message.error('请选择数据类型!')
          return
        }

        if (this.column_optional === '') {
          this.$message.error('请确认是否必须填写!')
          return
        }

        let column = {
          column_name: this.column_name,
          column_type: this.column_type,
          column_optional: this.column_optional,
          column_comment: this.column_comment,
          column_options: this.column_options,
          column_field_sample: this.column_field_sample
        }

        //如果是添加
        if (this.field_operation_type == 'ADD') {
          this.columnData.push(column)
        } else {
          // this.columnData[this.edit_field_index] = column
          this.columnData[this.edit_field_index].column_name = this.column_name
          this.columnData[this.edit_field_index].column_type = this.column_type
          this.columnData[this.edit_field_index].column_optional = this.column_optional
          this.columnData[this.edit_field_index].column_comment = this.column_comment
          this.columnData[this.edit_field_index].column_options = this.getOptionsFromStr(this.option_list_str)
          // this.columnData[this.edit_field_index].

          // console.log('$$$$$$$$$$$$$$$$',this.columnData[this.edit_field_index])


        }


        this.addColumnDialogVisible = false

        this.option_list_str = ''

        this.$forceUpdate()

        // this.$message({
        //   message: '"' + this.column_name + '"保存成功!',
        //   type: 'success'
        // })
        // this.$alert('暂存成功！注意：数据只是暂存状态，需要点底部的“保存表格”按钮才会生效哦！', {
        //   confirmButtonText: '知道了',
        // })

        this.$message({
          message: '暂存成功！注意：数据只是暂存状态，需要点底部的“保存表格”按钮才会生效哦！',
          type: 'success'
        })
        // this.$alert({
        //   message: '添加的列或修改的列只是暂存状态，需要点底部的“保存”按钮才会生效！',
        //   type: 'success'
        // })
      },
      isExistColumn(column_name) {
        // 列是否存在
        if (this.columnData.length === 0) return false
        for (var i = 0; i < this.columnData.length; i++) {
          let tmpObj = this.columnData[i]
          if (tmpObj.column_name === column_name) {
            return true
          }
        }

        return false
      },
      deleteClick(index) {
        var colName = this.columnData[index].column_name

        let that = this
        that.$confirm('确定要删除"' + colName + '"吗?', '操作提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let tmpColumnArray = []

          for (var i = 0; i < that.columnData.length; i++) {
            if (i !== index) {
              tmpColumnArray.push(that.columnData[i])
            }
          }

          that.columnData = []
          that.columnData = tmpColumnArray
        }).catch(() => {

        })
      },
      saveForm() {
        // 校验数据
        if (this.editForm.form_name === '') {
          this.$message.error('请输入表格名称')
          return
        }

        // 校验数据
        // if (this.editForm.input_pages === 0) {
        //   this.$message.error('请选择填表张数')
        //   return
        // }

        if (this.columnData.length === 0) {
          // this.$message.error('请添加表格数据列')
          this.$alert('表格中没有任何列,请先添加表格数据列！')
          // this.addColumnDialogVisible = true
          return
        }

        let that = this

        let data = {
          username: this.username,
          form_name: this.editForm.form_name,
          form_comment: this.editForm.form_comment,
          recieve_notice: this.editForm.recieve_notice,
          form_input_pages: '1',
          form_columns: JSON.stringify(that.columnData),
          form_id: this.form_id
        }

        console.log('ddddddddddddddddddd',data)

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_save_form.jsp'

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            load.close()
            that.saveFormSuccessDialogVisible = true
            // this.$alert('表格结构修改保存成功！')
          })
          .catch(function() {
            load.close()
            // that.$router.push('/form_list')
            // this.$alert('表格结构修改保存成功！1')
          })
      },
      // gotoFormList() {
      //   this.$router.push('/form_list')
      // },
      convertOptional(scope) {
        // console.log(scope.row.column_optional)
        if (scope.row.column_optional === '1') {
          return '可填可不填'
        } else {
          return '必须填写'
        }
      },
      moveUp(index) {
        if (index === 0) {
          this.$message({
            message: '已经是第一行了!',
            type: 'error'
          })

          return
        }

        // console.log(this.columnData)
        // console.log(this.columnData[index - 1].column_name)
        // console.log(this.columnData[index].column_name)
        // console.log('上移调整前1：', this.columnData)
        // console.log('index=', index)


        // column_name: this.column_name,
        // column_type: this.column_type,
        // column_optional: this.column_optional,
        // column_comment: this.column_comment,
        // column_options: this.column_options,
        // column_field_sample: this.column_field_sample




        let preObj = Object.assign({}, this.columnData[index - 1])
        let currentObj = Object.assign({}, this.columnData[index])

        // console.log('被替换移动的对象preObj：', preObj)
        // console.log('被替换移动的对象currentObj：', currentObj)

        this.columnData[index - 1].column_name = currentObj.column_name
        this.columnData[index - 1].column_type = currentObj.column_type
        this.columnData[index - 1].column_optional = currentObj.column_optional
        this.columnData[index - 1].column_comment = currentObj.column_comment
        this.columnData[index - 1].column_options = currentObj.column_options

        this.columnData[index].column_name = preObj.column_name
        this.columnData[index].column_type = preObj.column_type
        this.columnData[index].column_optional = preObj.column_optional
        this.columnData[index].column_comment = preObj.column_comment
        this.columnData[index].column_options = preObj.column_options

        // this.columnData[index - 1] = currentObj
        // this.columnData[index] = preObj

        // console.log('上移调整后2：', this.columnData)

        this.$forceUpdate()

        this.$message({
          message: '上移成功!',
          type: 'success'
        })
      },
      moveDown(index) {
        if (index === this.columnData.length - 1) {
          this.$message({
            message: '已经是最后一行了!',
            type: 'error'
          })

          return
        }

        let nextObj = Object.assign({}, this.columnData[index + 1])
        let currentObj = Object.assign({}, this.columnData[index])


        this.columnData[index + 1].column_name = currentObj.column_name
        this.columnData[index + 1].column_type = currentObj.column_type
        this.columnData[index + 1].column_optional = currentObj.column_optional
        this.columnData[index + 1].column_comment = currentObj.column_comment
        this.columnData[index + 1].column_options = currentObj.column_options

        this.columnData[index].column_name = nextObj.column_name
        this.columnData[index].column_type = nextObj.column_type
        this.columnData[index].column_optional = nextObj.column_optional
        this.columnData[index].column_comment = nextObj.column_comment
        this.columnData[index].column_options = nextObj.column_options


        // this.columnData[index + 1] = this.columnData[index]
        // this.columnData[index] = preObj
        // console.log('下移调整前2：', this.columnData)

        this.$forceUpdate()

        this.$message({
          message: '下移成功!',
          type: 'success'
        })

        // var newIndex = index + 1
      },
      selectColumnType() {
        // console.log(this.column_type, '%%%%%%%%%%%')


        if (this.column_type === '单选' || this.column_type === '多选') {
          this.addOptionsDialogVisible = true
        }
      },
      cancelOptionsToColumn() {
        // this.column_type = ''
        this.addOptionsDialogVisible = false
      },
      addOptionsToColumn() {
        // 分解字符串
        // let snsArr = this.option_list_str.split(/[(\r\n)\r\n]+/)

        // if (snsArr.length === 0) {
        //   this.cancelOptionsToColumn()
        //   return
        // }

        // snsArr.forEach((item, index) => {
        //   if (!item) {
        //     snsArr.splice(index, 1) // 删除空项
        //   }
        // })

        let snsArr = this.getOptionsFromStr(this.option_list_str)

        this.column_options = snsArr


        this.addOptionsDialogVisible = false
      },
      getOptionsFromStr(str) {
        let tmpArray = []
        let snsArr = this.option_list_str.split(/[(\r\n)\r\n]+/)
        if (snsArr.length === 0) {
          return snsArr
        }

        snsArr.forEach((item, index) => {
          if (!item) {
            snsArr.splice(index, 1) // 删除空项
          }
        })


        for (var i = 0; i < snsArr.length; i++) {
          var tmpStr = snsArr[i]

          if (!this.isExistStrInArray(tmpArray, tmpStr)) {
            tmpArray.push(tmpStr)
          }
        }

        console.log('去重后的结果', tmpArray)

        return tmpArray
      },
      isExistStrInArray(srcArray, str) {
        var isExist = false

        if (Utils.isEmpty(srcArray)) {
          return false
        } else {
          for (var i = 0; i < srcArray.length; i++) {
            var tmpStr = srcArray[i]

            if (tmpStr == str) {
              isExist = true
              break
            }
          }
        }


        return isExist
      },
      editSelectItems() {
        this.addOptionsDialogVisible = true
      },
      editClick(index) {
        this.field_operation_type = 'EDIT'
        this.edit_field_index = index
        this.field_action_title = '修改列'

        var colName = this.columnData[index].column_name
        this.addColumnDialogVisible = true



        this.column_name = colName
        this.column_type = this.columnData[index].column_type
        this.column_optional = '' + this.columnData[index].column_optional
        this.column_comment = this.columnData[index].column_comment

        if (this.column_type == '单选' || this.column_type == '多选') {
          this.option_list_str = this.arrayToLine(this.columnData[index].column_options)
        } else {
          this.option_list_str = ''
        }



      },
      arrayToLine(options) {
        var lines = ''
        if (Utils.isEmpty(options)) {
          return ''
        } else {
          for (var i = 0; i < options.length; i++) {
            if (i == 0) {
              lines = options[0]
            } else {
              lines = lines + '\n' + options[i]
            }
          }
        }

        return lines
      },
      loadFormStructure() {
        console.log('编辑数据')

        let that = this

        var requestUrl = '/form/web/_load_form_structure.jsp'
        // 开启loading

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              form_id: that.form_id
            }
          }).then(function(response) {
            that.form = response.data.form

            that.editForm.form_name = that.form.form_name
            that.editForm.form_comment = that.form.comment
            that.editForm.recieve_notice = that.form.receive_notice

            that.form_fields = response.data.form_fields

            for (var i = 0; i < that.form_fields.length; i++) {
              let field = that.form_fields[i]
              console.log('字段：', field)

              let field_options = ''

              if (field.field_type == '单选' || field.field_type == '多选') {
                field_options = JSON.parse(field.field_options)
              }



              let column = {
                column_name: field.field_name,
                column_type: field.field_type,
                column_optional: field.optional,
                column_comment: field.field_comment,
                column_options: field_options
              }

              // //如果是添加
              that.columnData.push(column)

            }




            load.close()
            that.$refs.dataList.doLayout()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      getOptionCount() {
        var count = 0

        // console.log('this.columnData',this.columnData)

        // if(this.columnData.length>0){
        //   let options = this.columnData[this.edit_field_index].column_options
        //   count = options.length
        // }

        count = this.column_options.length

        return count
      }

    }
  }
</script>

<style>
  .el-select-dropdown__wrap.el-scrollbar__wrap {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/make_form.vue